<div class="info">
    <mat-icon fontIcon="info"></mat-icon>
    <p>{{textConstants.NO_DATA_TO_SHOW}}</p>
  </div>
